import { ToastProps } from '@blueprintjs/core';
import { AnyAction } from '@reduxjs/toolkit';

export type NotificationAction = {
  text: string;
  actionButtonTestId?: string;
  onClickAction?: AnyAction;
};

export type NotificationMetadata = {
  actions?: NotificationAction[];
  dismissOnAction?: boolean;
  [key: string]: any;
};

export interface Notification extends ToastProps {
  id: string;
  type: string;
  data?: NotificationMetadata;
}

export class NotificationsState {
  constructor(public notifications: Notification[] = []) {}
}
